export const CHECKOUT_URL = 'https://horse-riding-instructor-pro.impultienda.ar/checkout'

export const OFFER_ANCHOR = '#offer'

export const PRODUCT_NAME = 'HORSE RIDING INSTRUCTOR PRO™'

export const PRODUCT_SUBTITLE =
  'The Complete Ready-to-Use System for Professional Riding Instructors'

export const PRODUCT_IMG =
  'https://cdn.magicpatterns.com/uploads/e9XJ3wuA8phtab3Jr7NoRD/ChatGPT-Image-19-ago-2026_-10_13_03-p.m..webp'

export const PRODUCT_ALT =
  'HORSE RIDING INSTRUCTOR PRO™ — complete 6-in-1 ready-to-use riding instruction system box set'

export const PRICE_FULL = '$97'

export const PRICE_TODAY = '$27'

export const SUPPORT_EMAIL = 'kitonline27@gmail.com'
